import axios from "axios";
import { Place } from "../types";

async function placeInfo(address: string): Promise<Place> {
  const response = await axios.get<Place>("/api/google_maps/place", {
    params: { address: address },
  });

  return Promise.resolve(response.data);
}

export default placeInfo;
